import { Avatar as GrommetAvatar } from 'grommet'
import styled from 'styled-components'

const StyledAvatar = styled(GrommetAvatar)`
    border: 1px solid gray;
`

export { StyledAvatar }
